import React from 'react';
import './App.css';
import data from './content/Portfolio.json';
import {BsBoxArrowUpRight} from 'react-icons/bs';

function Portfolio() {
  
  return (
    <div className="App">
    <div className="landing">
      <div className="landing-content-wrapper">
        <div className="landing-text-wrapper">
          <h2 className="landing-text-title">
            {data.Landing.title}
          </h2>
         
          <div className="landing-text-description">
            {data.Landing.text}
          </div>
        </div>
        <div className="landing-graphic-container">
          <img className="landing-graphic" src={data.Landing.image} alt="an image"/>
        </div>
      </div>
    </div>


{/* For the logos of all companies: */}
<div className="company-blob-wrapper">
    {data.companies.concat(data.old_companies).map(company => (
      <div className="company-wrapper"> 
        <a href={company.website}  className="link-text" rel="noreferrer" target="_blank"> <img src={company.logo} className="company-logo" alt=""/> </a>
      </div>
    ))}
    </div>

    {/* For displaying current portfolio companies */}
        
        {/* {data.companies.map(company => (
            <div className="content" style={{paddingBottom:'1rem', paddingTop:'1rem'}}>
        <div className="content-wrapper">
          <div className="content-text-wrapper">
            <div className="content-text-heading">
              <h3>{company.name}</h3>
            </div>
            <div className="content-text-description">
              <p>{company.text}</p>
              <hr/>
              <a href={company.website}  className="link-text" rel="noreferrer" target="_blank"> Website  <BsBoxArrowUpRight style={{verticalAlign:'middle'}}/> </a>
            </div>
          </div>
          
            <div className="portfolio-image-wrapper">
              <img  src={company.logo} className="portfolio-logo" alt="image here"/>
          </div>
        </div>
      </div>    
          ))} */}


    </div>
  );
}

export default Portfolio;
